import { DeploymentService } from "@packages/client";
import { useNavigate, useLocation } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";
import getUrl from "Libs/getUrl";
import { selectFeatureAutoscalingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import type { ModifiedDeploymentService } from "Reducers/environment/deployment";

export const useAutoscalingConfigLink = (
  service?: Partial<DeploymentService> | ModifiedDeploymentService
) => {
  const { organizationId, projectId, environmentId } = useDecodedParams();
  const navigate = useNavigate();
  const location = useLocation();

  const autoscalingEnabledFlag = useAppSelector(
    selectFeatureAutoscalingEnabled
  );

  const handleConfigureAutoscaling = () => {
    if (!organizationId || !projectId || !environmentId) return;
    const autoscaleConfigUrl = getUrl({
      key: "organization.project.environment.configureAutoscaling",
      props: {
        organizationId,
        projectId,
        environmentId: environmentId || "",
        location: location.pathname,
        queryParams: ""
      }
    });
    navigate(autoscaleConfigUrl, {
      state: service ? { service } : undefined
    });
  };

  return { autoscalingEnabledFlag, handleConfigureAutoscaling };
};
